import React from 'react';
import { Card, Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';

export function AvailableModuleForm({ availableModule, Controller, control }) {
  const renderAccessList = () => (
    <div className="">
      <div className="w-full px-1 ">
        <div className="w-full px-1">
          <Controller
            name={'DASHBOARD'}
            control={control}
            defaultValue={availableModule?.DASHBOARD || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="แดชบอร์ด"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'SPM'}
            control={control}
            defaultValue={availableModule?.SPM || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="การขาย"
              />
            )}
          />
        </div>{' '}
        <div className="w-full px-1 py-1">
          <Controller
            name={'PMS'}
            control={control}
            defaultValue={availableModule?.PMS || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="การจัดซื้อ"
              />
            )}
          />
        </div>{' '}
        <div className="w-full px-1 py-1">
          <Controller
            name={'MMS'}
            control={control}
            defaultValue={availableModule?.MMS || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="การผลิต"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'IMS'}
            control={control}
            defaultValue={availableModule?.IMS || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="คลังวัตถุดิบ"
              />
            )}
          />{' '}
        </div>{' '}
        <div className="w-full px-1 py-1">
          <Controller
            name={'WMS'}
            control={control}
            defaultValue={availableModule?.WMS || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="คลังสินค้า"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'CRM'}
            control={control}
            defaultValue={availableModule?.CRM || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="ลูกค้าสัมพันธ์"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'KM'}
            control={control}
            defaultValue={availableModule?.KM || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="คลังข้อมูลองค์กร"
              />
            )}
          />
        </div>{' '}
        <div className="w-full px-1 py-1">
          <Controller
            name={'MAMS'}
            control={control}
            defaultValue={availableModule?.MAMS || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="เครื่องจักร / รางการผลิต"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'PAMS'}
            control={control}
            defaultValue={availableModule?.PAMS || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="เงินเดือนและการจ่ายค่าตอบแทน"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'DOC'}
            control={control}
            defaultValue={availableModule?.DOC || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="จัดการเอกสาร (สำหรับใช้กับระบบ E-Warehouse)"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'CEM'}
            control={control}
            defaultValue={availableModule?.CEM || false}
            rules={{ required: false }}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} defaultChecked={field.value} />}
                label="ประมาณการต้นทุน"
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <FormControlLabel
            control={<Checkbox defaultChecked={true} disabled={true} />}
            label="ทรัพยากรบุคคล"
          />
        </div>
        <div className="w-full px-1 py-1">
          <FormControlLabel
            control={<Checkbox defaultChecked={true} disabled={true} />}
            label="การตั้งค่า"
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-row flex-wrap">
      <Card className="w-full p-4">
        <div> {renderAccessList()} </div>
      </Card>
    </div>
  );
}

AvailableModuleForm.propTypes = {
  availableModule: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

AvailableModuleForm.defaultProps = {
  information: null,
};

export default AvailableModuleForm;
